'use strict';
import React, { PureComponent } from 'react';
import GrupoRadioButton from '../../../Common/GrupoRadioButton';


class DatosGenerales extends PureComponent {
    constructor(props) {
        super(props);

        this.validarInput = this.validarInput.bind(this);
    }

    validarInput(event, nombreInput) {
        let valorInput = event.target.value;
        this.props.limpiarMensajeErrorPorNombre("modalAltaEdicionRenglonContable",nombreInput);
        this.props.cambiarValorInput("modalAltaEdicionRenglonContable", nombreInput, valorInput);
    
    }

    render() {
        const {
            checkAperturaPorSocio,
            errorValidacion,
            inputsModal,
            rbModalAltaEdicionRenglonContable
        } = this.props;

        // ACTIONS
        const {
            seleccionarRadioButtonABMModelos
        } = this.props;

        let rbTipoRenglon = rbModalAltaEdicionRenglonContable.rbTipoRenglon;
        let rbTipoApertura = rbModalAltaEdicionRenglonContable.rbTipoApertura;
        let rbReferenciaRenglon = rbModalAltaEdicionRenglonContable.rbReferenciaRenglon;
        
  

        return (
            <div>
                <div className="ABMModelosModalContainer__subtitulo ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorSubtitulo">Datos generales</div>

                <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorDescripcion ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorDescripcion">
                    <div className="seccionDatosGenerales__tituloSecundario">Descripción</div>
                    <div>
                        <input 
                            type="text" 
                            className="seccionDatosGenerales__inputSelect ABMModelosModalContainer__descripcionInput" 
                            name="inputDescripcion" 
                            id="inputDescripcion" 
                            onChange={(event) => this.validarInput(event, "inputDescripcion")}
                            placeholder="Ingrese descripción..." 
                            value={inputsModal.inputDescripcion}
                        />
                    </div>
                    {errorValidacion.modalAltaEdicionRenglonContable.inputDescripcion ? 
                        <div>
                            <label className="error">{errorValidacion.modalAltaEdicionRenglonContable.inputDescripcion}</label>
                        </div>
                    :
                        null
                    }
                </div>

                <div className="ABMModelosModalContainer__contenedorGrupoRadioButtons">
                    <div className="seccionDatosGenerales__tituloSecundario">Tipo de renglón</div>

                    <div>
                        <div className="ABMModelosModalContainer__contenedorRadioButtonIzquierda ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonIzquierda">
                            <GrupoRadioButton 
                                activo={rbTipoRenglon == 1}
                                classLabel={""}
                                estaHabilitado={true}
                                label={"Automático"}
                                nombre={"rbTipoRenglon"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={1}
                            />
                        </div>

                        <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonMedio">
                            <GrupoRadioButton 
                                activo={rbTipoRenglon == 2}
                                classLabel={""}
                                estaHabilitado={true}
                                label={"Manual"}
                                nombre={"rbTipoRenglon"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={2}
                            />
                        </div>

                        <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha">
                            <GrupoRadioButton 
                                activo={rbTipoRenglon == 3}
                                classLabel={""}
                                estaHabilitado={true}
                                label={"Balanceo"}
                                nombre={"rbTipoRenglon"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={3}
                            />
                        </div>
                    </div>
                </div>
                  {rbTipoRenglon == 1 ?   
                    <div className="ABMModelosModalContainer__contenedorGrupoRadioButtons">
                        <div className="seccionDatosGenerales__tituloSecundario">Tipo de apertura</div>
                    <div>
                    {checkAperturaPorSocio ?

                    null 
                    :
                        <div>
                            <div className="ABMModelosModalContainer__contenedorRadioButtonIzquierda ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonIzquierda">
                                <GrupoRadioButton 
                                    activo={rbTipoApertura == 1}
                                    classLabel={""}
                                    estaHabilitado={true}
                                    label={"Sin Apertura"}
                                    nombre={"rbTipoApertura"}
                                    onClick={seleccionarRadioButtonABMModelos}
                                    seccion={"modalAltaEdicionRenglonContable"}
                                    valor={1}
                                />
                            </div>
                        </div>
                    }
                        <div className={checkAperturaPorSocio ? "ABMModelosModalContainer__contenedorRadioButtonIzquierda ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonIzquierda" 
                            : "ABMModelosModalContainer__contenedorRadioButtonDerecha ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonMedio"}>
                                <GrupoRadioButton 
                                    activo={rbTipoApertura == 2}
                                    classLabel={""}
                                    estaHabilitado={true}
                                    label={"Por Socio"}
                                    nombre={"rbTipoApertura"}
                                    onClick={seleccionarRadioButtonABMModelos}
                                    seccion={"modalAltaEdicionRenglonContable"}
                                    valor={2}
                                />
                            </div>

                            <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha">
                                <GrupoRadioButton 
                                    activo={rbTipoApertura == 3}
                                    classLabel={""}
                                    estaHabilitado={true}
                                    label={"Por Movimiento"}
                                    nombre={"rbTipoApertura"}
                                    onClick={seleccionarRadioButtonABMModelos}
                                    seccion={"modalAltaEdicionRenglonContable"}
                                    valor={3}
                                />
                            </div>
                        </div>
                    </div>
                    :
                    null
                }
                <div className="ABMModelosModalContainer__contenedorGrupoRadioButtons_margenEstrecho">
                    <div className="seccionDatosGenerales__tituloSecundario">Referencia de renglón</div>

                    <div>
                        <div className="ABMModelosModalContainer__contenedorRadioButtonIzquierda ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonIzquierda">
                            <GrupoRadioButton 
                                activo={rbReferenciaRenglon == 0}
                                classLabel={""}
                                estaHabilitado={true}
                                label={"Ninguna"}
                                nombre={"rbReferenciaRenglon"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={0}
                            />
                        </div>
                        {rbTipoApertura == 1 ?
                        null
                        :
                        <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha ABMModelosModalContainer__modalAltaEdicionRenglonContable__contenedorRadioButtonMedio">
                            <GrupoRadioButton 
                                activo={rbReferenciaRenglon == 1}
                                classLabel={""}
                                estaHabilitado={true}
                                label={"Cuenta del Socio"}
                                nombre={"rbReferenciaRenglon"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={1}
                            />
                        </div>
            }
                        <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha">
                            <GrupoRadioButton 
                                activo={rbReferenciaRenglon == 2}
                                classLabel={""}
                                estaHabilitado={true}
                                label={"Ref. cuenta contable"}
                                nombre={"rbReferenciaRenglon"}
                                onClick={seleccionarRadioButtonABMModelos}
                                seccion={"modalAltaEdicionRenglonContable"}
                                valor={2}
                            />
                        </div>
                        <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha_otra">
                            <div>
                              <GrupoRadioButton 
                                    activo={rbReferenciaRenglon == 3}
                                    classLabel={""}
                                    estaHabilitado={true}
                                    label={"Otra:"}
                                    nombre={"rbReferenciaRenglon"}
                                    onClick={seleccionarRadioButtonABMModelos}
                                    seccion={"modalAltaEdicionRenglonContable"}
                                    valor={3}
                                />
                            </div>
                        </div>
                        <div className="ABMModelosModalContainer__ubicacionCopia__contenedorPosicionInput">
                            <input type="text" 
                                disabled={!(rbReferenciaRenglon == 3)}
                                className="seccionDatosGenerales__inputSelect ABMModelosModalContainer__referenciaRenglonInput"
                                name="inputReferenciaRenglon"
                                id="inputReferenciaRenglon"
                                onChange={(event) => rbReferenciaRenglon == 3 ? this.validarInput(event, "inputReferenciaRenglon"): null}
                                value={inputsModal.inputReferenciaRenglon} 
                             />
                        </div>
                    </div>
                </div>

                {rbReferenciaRenglon == 3 && rbTipoApertura == 1 && errorValidacion.modalAltaEdicionRenglonContable.inputReferenciaRenglon ? 
                    <div>
                        <label className="error ABMModelosModalContainer_errorPaddingLeftOtra">{errorValidacion.modalAltaEdicionRenglonContable.inputReferenciaRenglon}</label>
                    </div>
                :
                    null
                }

                {rbReferenciaRenglon == 3 && rbTipoApertura != 1 && errorValidacion.modalAltaEdicionRenglonContable.inputReferenciaRenglon ? 
                    <div>
                        <label className="error ABMModelosModalContainer_errorPaddingLeftOtra_Largo">{errorValidacion.modalAltaEdicionRenglonContable.inputReferenciaRenglon}</label>
                    </div>
                :
                    null
                }

                <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__lineaDivisoria"></div>
            </div>
        );
    }
}

export default DatosGenerales;